export default function Above_and_Below_Average() {
  return <div>Above_and_Below_Average</div>;
}
